// These methods are used to track components being rendered on the document.
// Needed until we are using react to render the entire document and don't
// rely on backbone or other front end frameworks.
let registry = [];

export const register = (selector) => {
  registry.push(selector);
};

export const getSelectors = () => registry;

export const clear = () => {
  registry = [];
};



// WEBPACK FOOTER //
// ./src/shared/component-registry.js